import { render } from "./ModalBackdrop.vue?vue&type=template&id=2cae771e"
const script = {}

import "./ModalBackdrop.vue?vue&type=style&index=0&id=2cae771e&lang=css"
script.render = render

export default script